import { ArrowUpRight, Check } from 'lucide-react';

const plans = [
  {
    id: 'monthly',
    className: 'eldgard-price-card',
    label: 'One named developer',
    title: 'Monthly subscription',
    price: '$6',
    interval: 'USD · per month',
    note: 'Renews automatically each month. Cancel anytime; desktop access ends when your paid billing period ends.',
  },
  {
    id: 'yearly',
    className: 'eldgard-price-card eldgard-price-card-primary',
    label: 'One named developer · Two months free',
    title: 'Yearly subscription',
    price: '$60',
    interval: 'USD · per year ($5/month)',
    note: 'Billed $60 yearly, saving $12 compared with 12 monthly payments. Renews automatically each year. Cancel anytime; desktop access ends when your paid billing period ends.',
  },
] as const;

const benefits = [
  'Use on two desktop computers',
  'macOS, Windows, and Linux included',
  'Updates and standard support while subscribed',
  'Unlimited local and cloud Firestore projects',
  'Personal and commercial work',
] as const;

export function EldgardPricing({ contactHref }: { contactHref: string }) {
  return (
    <section
      className="eld-container eldgard-pricing eldgard-section"
      id="pricing"
      aria-labelledby="pricing-heading"
    >
      <div className="eldgard-section-heading">
        <div>
          <p className="eldgard-eyebrow">05 / Planned pricing</p>
          <h2 id="pricing-heading">
            Your workspace.
            <br />
            Your choice.
          </h2>
        </div>
        <p>
          Subscribe monthly or save with a yearly plan.
          <br />
          Both plans include full desktop access.
        </p>
      </div>
      <p className="eldgard-pricing-status">
        <span className="eldgard-status-dot" aria-hidden="true" />
        Planned pricing—not on sale yet. Prices and subscription terms may
        change before launch. Purchases and trials are not available yet.
      </p>
      <div className="eldgard-pricing-grid">
        {plans.map((plan) => (
          <article
            className={plan.className}
            key={plan.id}
            aria-labelledby={`${plan.id}-heading`}
          >
            <p className="eldgard-price-label">{plan.label}</p>
            <h3 id={`${plan.id}-heading`}>{plan.title}</h3>
            <p className="eldgard-price">
              <span>{plan.price}</span> <span>{plan.interval}</span>
            </p>
            <a className="eldgard-button" href={contactHref}>
              Request early access
              <ArrowUpRight size={17} aria-hidden="true" />
            </a>
            <p className="eldgard-price-note">{plan.note}</p>
          </article>
        ))}
      </div>
      <div className="eldgard-pricing-includes">
        <h3>Included with either plan</h3>
        <ul className="eldgard-license-includes">
          {benefits.map((benefit) => (
            <li key={benefit}>
              <Check size={18} aria-hidden="true" />
              {benefit}
            </li>
          ))}
        </ul>
      </div>
      <div className="eldgard-pricing-footnotes">
        <p className="eldgard-trial-note">
          Planned for both subscriptions: a 14-day full-access trial. No card
          required.
        </p>
        <p>
          One subscription per developer. Your Firestore usage is billed
          separately by Google.
        </p>
        <p>
          The iOS and Android reader is planned to be free at launch. No paid
          desktop plan required.
        </p>
      </div>
    </section>
  );
}
